import React from 'react';
import { NavLink } from 'react-router-dom';

import Modal from 'antd/es/modal/Modal';

import GetInTouchForm from '@app/components/UI/Forms/GetInTouch/GetInTouchForm';
import { pushEvent } from '@app/components/TagManager';
import { PhoneProviderContext } from '@app/providers/PhoneProvider/PhoneProvider';
import PhoneSVG from '@app/images/PhoneSVG';
import '@app/scss/components/getInTouch.scss';

interface GetInTouchButtonProps {
	btnText?: string;
	btnClassName?: string;
	openFormInModal?: boolean;
}

const GetInTouchButton: React.FC<GetInTouchButtonProps> = ({
	btnText = 'Get In Touch',
	btnClassName = 'btn btn-sm btn-primary',
	openFormInModal = false,
}) => {
	const [isVisible, setIsVisible] = React.useState(false);
	const [sent, setSent] = React.useState(false);

	const closeDialog = () => setIsVisible(false);

	const contextPhone = React.useContext(PhoneProviderContext);

	if (!contextPhone?.state) throw new Error('Error PhoneProvider context');

	return !openFormInModal ? (
		<NavLink to="/online-booking" className={btnClassName} onClick={() => pushEvent('onlineBookingScheduleBtnClick')}>
			{btnText}
		</NavLink>
	) : (
		<>
			<button type="button" className={btnClassName} onClick={() => setIsVisible(true)}>
				{btnText}
			</button>
			<Modal
				open={isVisible}
				title={<p>We're here to help</p>}
				onCancel={closeDialog}
				className="get-in-touch"
				wrapClassName="get-in-touch-back modal-wrap"
				footer={null}
				width={1008}
				centered
				destroyOnClose
			>
				<div className="get-in-touch-form">
					<GetInTouchForm onSubmit={() => setSent(true)} />
				</div>
				<div className="get-in-touch-info">
					<h2 className="get-in-touch-info__title">
						{sent ? (
							<>
								Thank you for reaching out to us.
								<br />
								A Care Coordinator will return
								<br />
								your message soon.
							</>
						) : (
							<>Have questions? Give us a call. One of our Veterinary Care Coordinators would love to help.</>
						)}
					</h2>
					<p className="get-in-touch-info__text">
						{sent ? (
							<>If you need immediate assistance, please call us at</>
						) : (
							<>Our Lap of Love Support Center is available 24/7, every day of the year, including weekends and holidays.</>
						)}
					</p>
					<a className="get-in-touch-info__phone" href="tel:855-933-5683">
						<span className="get-in-touch-info__phone-icon">
							<PhoneSVG />
						</span>
						<span>{contextPhone.state.phoneNumberDisplay}</span>
					</a>
				</div>
			</Modal>
		</>
	);
};

export default GetInTouchButton;
